export default {
  state: {
    showStaticLogo: true
  },
  mutations: {
    updateShowStaticLogo(state, payload) {
      state.showStaticLogo = payload;
    }
  }
};
